<template>
  <article class="popup add-info-block-popup">
    <header class="popup-top">
      <h2 class="title">{{$t('index.journal.addInfoBlock.typeOfBlock')}}</h2>
      <div class="popup-top_btns">
        <question-btn :text="$t('prompts.addInfoBlock')"></question-btn>
        <close-btn class="static"></close-btn>
      </div>
    </header>
    <div class="popup-middle">
      <button class="info-card" :disabled="newEvent.textBlock" :class="{'selected': blockSelected === 'textBlock'}" @click="selectBlock('textBlock')">
        <textBlockIcon />
        <p>{{$t('index.journal.addInfoBlock.textBlock')}}</p>
      </button>
      <button class="info-card" :disabled="newEvent.commentsBlock" :class="{'selected': blockSelected === 'commentsBlock'}" @click="selectBlock('commentsBlock')">
        <commentBlockIcon />
        <p>{{$t('index.journal.addInfoBlock.commentsBlock')}}</p>
      </button>
      <button class="info-card" :disabled="newEvent.enclosureBlock" :class="{'selected': blockSelected === 'enclosureBlock'}" @click="selectBlock('enclosureBlock')">
        <attachBlockIcon />
        <p>{{$t('index.journal.addInfoBlock.filesBlock')}}</p>
      </button>
    </div>
    <div class="popup-down">
      <button class="btn btn-transparent_blue" @click="closeAll">{{$t('index.journal.edit.cancelButton')}}</button>
      <button class="btn btn-blue" :class="{'loading': loading}" :disabled="disabled || loading" @click="addBlockToNewEvent">{{$t('index.journal.addInfoBlock.addButton')}}</button>
    </div>
  </article>
</template>

<script>
  import closeBtn from '../closeBtn'
  import questionBtn from '../questionBtn'
  import {popups} from "../../../mixins/popups";

  //3 icons
  import textBlockIcon from '../../Svg/journal/popupIcons/textBlockIcon'
  import commentBlockIcon from '../../Svg/journal/popupIcons/commentBlockIcon'
  import attachBlockIcon from '../../Svg/journal/popupIcons/attachBlockIcon'

  import {mapMutations, mapGetters} from 'vuex'

  export default {
    name: "addInfoBlock",
    mixins: [popups],
    components: {
      closeBtn,
      questionBtn,
      textBlockIcon,
      commentBlockIcon,
      attachBlockIcon
    },
    data() {
      return {
        loading: false,
        blockSelected: ''
      }
    },
    computed: {
      ...mapGetters({
        newEvent: 'journal/event'
      }),
      disabled() {
        return !this.blockSelected
      },
    },
    methods: {
      ...mapMutations({
        setTextBlock: 'journal/SET_TEXT_BLOCK',
        setCommentsBlock: 'journal/SET_EVENT_COMMENTS_BLOCK',
        setEnclosureBlock: 'journal/SET_EVENT_ENCLOSURE_BLOCK',
      }),
      selectBlock(block) {
        this.blockSelected = block
      },
      addBlockToNewEvent() {
        this.loading = true;
        switch (this.blockSelected) {
          case ("commentsBlock"): {
            this.setCommentsBlock(true)
          };
          break;
          case ("enclosureBlock"): {
            this.setEnclosureBlock(true)
          };
          break;
          case ("textBlock"): {
            this.setTextBlock(true)
          };
          break;
        }
        this.closeAll()
      },
    }
  }
</script>

<style lang="scss">
  .add-info-block-popup {
    .info-card {
      svg path {
        transition: all .3s;
      }
      &:hover, &.selected {
        &:not(:disabled) {
          color: white;
          background-color: $blue;
          svg path {
            fill: white;
          }
          svg g {
            opacity: 1;
          }
        }
      }
      &:disabled {
        opacity: .4;
        cursor: not-allowed;
      }
    }
  }
</style>

<style lang="scss" scoped>
.popup {
  width: 500px !important;
  max-width: none !important;
}
.add-info-block-popup {
  background-color: white;
  box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
  border-radius: 8px;
  width: 500px !important;
  padding: 30px !important;
}
.popup-top {
  padding-bottom: 30px;
  margin-bottom: 0 !important;
}
.popup-middle {
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
}
.info-card {
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: #D7E3EA;
  border-radius: 4px;
  color: $darkBlue;
  p {
    margin-top: 10px;
    font-family: $mm;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
  }
}
.popup-down {
  display: flex;
  justify-content: flex-end;
  .btn {
    width: 170px;
    margin-left: 20px;
  }
}
</style>
